/*
  Vina en Rose — wishlist
  Client-side only (localStorage). There is no Shopify backend for this,
  so a wishlist saved on one device/browser will not follow the customer
  to another device. If a persistent, cross-device wishlist is needed
  later, that requires a wishlist app (e.g. from the Shopify App Store)
  wired to the customer's account instead of localStorage.
*/
(function () {
  'use strict';

  var STORAGE_KEY = 'vina_wishlist';

  function getWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* localStorage unavailable (private browsing, etc.) — fail silently */
    }
  }

  function isSaved(id) {
    return getWishlist().some(function (item) { return String(item.id) === String(id); });
  }

  function toggleItem(data) {
    var items = getWishlist();
    var index = items.findIndex(function (item) { return String(item.id) === String(data.id); });
    if (index > -1) {
      items.splice(index, 1);
    } else {
      items.push(data);
    }
    saveWishlist(items);
    renderAll();
  }

  function removeItem(id) {
    var items = getWishlist().filter(function (item) { return String(item.id) !== String(id); });
    saveWishlist(items);
    renderAll();
  }

  function updateHeaderCount() {
    var count = getWishlist().length;
    var badge = document.getElementById('vina-wishlist-count');
    if (!badge) return;
    badge.textContent = String(count);
    badge.hidden = count === 0;
  }

  function updateHearts() {
    document.querySelectorAll('[data-vina-wishlist-item]').forEach(function (btn) {
      var id = btn.getAttribute('data-id');
      btn.classList.toggle('is-saved', isSaved(id));
    });
  }

  function ensureDrawer() {
    var existing = document.getElementById('vina-wishlist-drawer');
    if (existing) return existing;

    var drawer = document.createElement('div');
    drawer.id = 'vina-wishlist-drawer';
    drawer.className = 'vina-wishlist-drawer';
    drawer.innerHTML =
      '<div class="vina-wishlist-drawer__overlay" data-vina-wishlist-close></div>' +
      '<div class="vina-wishlist-drawer__panel" role="dialog" aria-label="Wishlist">' +
      '  <div class="vina-wishlist-drawer__head">' +
      '    <span class="script">Your Wishlist</span>' +
      '    <button type="button" class="vina-wishlist-drawer__close" data-vina-wishlist-close aria-label="Close">&times;</button>' +
      '  </div>' +
      '  <div class="vina-wishlist-drawer__body" id="vina-wishlist-drawer-body"></div>' +
      '</div>';
    document.body.appendChild(drawer);

    drawer.querySelectorAll('[data-vina-wishlist-close]').forEach(function (el) {
      el.addEventListener('click', function () { closeDrawer(); });
    });

    return drawer;
  }

  function renderDrawerBody() {
    var body = document.getElementById('vina-wishlist-drawer-body');
    if (!body) return;
    var items = getWishlist();

    if (items.length === 0) {
      body.innerHTML = '<p class="vina-wishlist-empty">Nothing saved yet — tap the heart on anything you love.</p>';
      return;
    }

    body.innerHTML = items.map(function (item) {
      return (
        '<div class="vina-wishlist-row">' +
        (item.image ? '<a href="' + item.url + '" class="vina-wishlist-row__img"><img src="' + item.image + '" alt="' + item.title + '" loading="lazy"></a>' : '<a href="' + item.url + '" class="vina-wishlist-row__img vina-wishlist-row__img--empty"></a>') +
        '<div class="vina-wishlist-row__info">' +
        '  <a href="' + item.url + '" class="script">' + item.title + '</a>' +
        '  <div class="price">' + (item.price || '') + '</div>' +
        '</div>' +
        '<button type="button" class="vina-wishlist-row__remove" data-remove-id="' + item.id + '" aria-label="Remove">&times;</button>' +
        '</div>'
      );
    }).join('');

    body.querySelectorAll('[data-remove-id]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeItem(btn.getAttribute('data-remove-id'));
      });
    });
  }

  function openDrawer() {
    var drawer = ensureDrawer();
    renderDrawerBody();
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
  }

  function closeDrawer() {
    var drawer = document.getElementById('vina-wishlist-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function renderAll() {
    updateHeaderCount();
    updateHearts();
    renderDrawerBody();
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateHeaderCount();
    updateHearts();

    document.addEventListener('click', function (e) {
      var heart = e.target.closest('[data-vina-wishlist-item]');
      if (heart) {
        e.preventDefault();
        toggleItem({
          id: heart.getAttribute('data-id'),
          title: heart.getAttribute('data-title'),
          url: heart.getAttribute('data-url'),
          image: heart.getAttribute('data-image'),
          price: heart.getAttribute('data-price')
        });
        return;
      }

      if (e.target.closest('#vina-wishlist-button')) {
        e.preventDefault();
        openDrawer();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  });
})();
